import React, { useEffect, useState } from 'react';
import InicioSlider from './InicioSlider';
import WeatherProducts from './WeatherProducts';
import OfferGrid from './OfferGrid';
import ServicesSection from './ServicesSection';
import AIProductsSection from './AIProductsSection';
import AIChatSection from './AIChatSection';
import SEO from '../shared/SEO';
import { DEFAULT_SEO_DESCRIPTION } from '../../config/siteContent';

const Inicio = () => {
  const [homeContent, setHomeContent] = useState(null);
  const [weatherEnabled, setWeatherEnabled] = useState(true);

  useEffect(() => {
    const loadHomeContent = async () => {
      try {
        const [contentRes, storeRes] = await Promise.all([
          fetch(`${process.env.REACT_APP_API_URL}/home-content`),
          fetch(`${process.env.REACT_APP_API_URL}/store-config`)
        ]);
        const contentData = await contentRes.json();
        const storeData = await storeRes.json();

        if (contentRes.ok && contentData.success) {
          setHomeContent(contentData.data);
        }
        if (storeRes.ok && storeData.success) {
          setWeatherEnabled(storeData.data?.weatherEnabled !== false);
        }
      } catch (error) {
        console.error('Error loading home content:', error);
      }
    };

    loadHomeContent();
  }, []);

  return (
    <>
      <SEO
        title="Ropa Urbana y Deportiva en Uruguay"
        description={DEFAULT_SEO_DESCRIPTION}
        url="/"
        type="website"
      />
      <div id="inicio">
        <header>
          <InicioSlider
            enabled={homeContent?.slider?.enabled}
            slides={homeContent?.slider?.slides}
          />
        </header>
        <main>
          {weatherEnabled && <WeatherProducts />}
          <OfferGrid featuredCategories={homeContent?.featuredCategories} />
          <AIProductsSection />
          <ServicesSection />
          <AIChatSection />
          <section className="home-business-intro">
            <div className="container">
              <h1>Rem Urban Clothes — Fabricantes de indumentaria en Ciudad de la Costa, Uruguay</h1>
              <p>Somos una empresa uruguaya de fabricación propia de indumentaria urbana y deportiva para mujer, hombre y niños. Venta minorista y mayorista, con envíos a todo Uruguay.</p>
            </div>
          </section>
        </main>
      </div>
    </>
  );
};

export default Inicio;
